// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nsr-addon-product-gallery{width:550px;float:left}", "",{"version":3,"sources":["webpack://./src/product-detail/ProductGallery.scss"],"names":[],"mappings":"AAAA,2BACC,WAAA,CACG,UAAA","sourcesContent":[".nsr-addon-product-gallery {\n\twidth: 550px;\n    float: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
